<template>
  <div class="row">
    <div class="col-sm-6">
      <EmailForm />
    </div>
    <div class="col-sm-6">
      <EmailPreview />
    </div>
  </div>
</template>

<script>
import EmailForm from "./components/EmailForm.vue";
import EmailPreview from "./components/EmailPreview.vue";

export default {
  components: {
    EmailForm,
    EmailPreview
  }
};
</script>
